export default "__VITE_ASSET__4Fz$T9Zg__"